module.exports = __webpack_public_path__ + "static/media/OpenSansRegular.3ed9575d.ttf";